import React from "react";
import { useSearchParams, Link, Navigate } from "react-router-dom";

const Success = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  // Instantly redirect to homepage if accessed without a session_id
  if (!sessionId) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      style={{
        backgroundColor: "#121212",
        minHeight: "calc(100vh - 80px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          backgroundColor: "#1a1a1a",
          border: "1px solid #333",
          borderRadius: "12px",
          maxWidth: "600px",
          width: "100%",
          padding: "50px 40px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "50px", marginBottom: "20px" }}>✅</div>
        <h1
          style={{ color: "#2ecc71", margin: "0 0 15px 0", fontSize: "2rem" }}
        >
          Payment Successful!
        </h1>

        <p
          style={{
            fontSize: "1.1rem",
            color: "#bbb",
            lineHeight: "1.6",
            margin: "0 auto 30px auto",
          }}
        >
          Thank you for booking your CITB Training & CSCS Card package. Your
          slot is now secured.
        </p>

        <div
          style={{
            backgroundColor: "#101a14" /* Changed to subtle green tint */,
            padding: "25px",
            margin: "20px 0",
            border: "1px solid #333",
            borderLeft: "4px solid #2ecc71" /* Changed to Green */,
            borderRadius: "6px",
            textAlign: "left",
          }}
        >
          <p
            style={{
              color: "#f0e6d2",
              margin: "0 0 10px 0",
              fontSize: "1.05rem",
            }}
          >
            <strong>Check your inbox!</strong>
          </p>
          <p style={{ color: "#bbb", margin: 0, lineHeight: "1.5" }}>
            We've sent a confirmation email with your booking details and what
            you need to bring on the day of your test. Please check your
            spam/junk folder if you don't see it in your inbox.
          </p>
        </div>

        <Link
          to="/"
          style={{
            display: "inline-block",
            marginTop: "20px",
            padding: "16px 24px",
            backgroundColor: "#2ecc71" /* Changed to Green */,
            color: "#121212",
            textDecoration: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            fontSize: "1.05rem",
          }}
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Success;
